//@ts-nocheck
import { ToastContainer } from "react-toastify";
import MarketingV2 from "./marketing-v2/MarketingV2";

// Pazarlama sitesi v2: yeni tasarım kendi Header/Footer ve hash-routing'ini yönetir.
// Eski Navbar/routes/Footer ve ilgili bileşenler repoda korunuyor (ödeme/kayıt akışı
// Faz 6'da yeni login/register ekranına bağlanacak).
function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      <MarketingV2 />
    </>
  );
}

export default App;
